import { Type } from 'class-transformer';

import { EmailSender } from './email_sender';
import { Organization } from './organization';
import { Capability, User, UserRoleLevel } from './user';

interface OrganizationMembership {
  display_name: string;
  id: string;
}

export class Profile extends User {
  is_email_verified: boolean;

  @Type(() => EmailSender)
  default_email_sender: EmailSender | null;

  @Type(() => Organization)
  organization: Organization;

  organizations: OrganizationMembership[];

  capabilities: Partial<Record<Capability, boolean>> = {};

  can(capability: Capability): boolean {
    return this.capabilities[capability] === true;
  }

  get canEditTemplates(): boolean {
    return this.userRole === UserRoleLevel.Admin || this.userRole === UserRoleLevel.Manager;
  }

  get isCashAppEnabled(): boolean {
    return this.organization?.is_cash_app_enabled ?? false;
  }

  get isDeductionsEnabled(): boolean {
    return this.organization?.is_deductions_enabled ?? false;
  }

  get isDisputesEnabled(): boolean {
    return this.organization?.is_disputes_enabled ?? false;
  }

  get canLinkEmail(): boolean {
    // Nylas orgs and hybrid orgs (SendGrid send + Nylas read) can link emails
    return (
      (this.organization?.email_provider === 'nylas' || this.organization?.hybrid_mode_enabled) ??
      false
    );
  }

  get isEmailSenderSetup(): boolean {
    // Nylas and hybrid orgs need a linked email sender
    if (this.canLinkEmail) {
      return Boolean(this.default_email_sender_id);
    }
    // Pure SendGrid orgs have senders provisioned by admin
    return true;
  }
}
